import {ThemeProvider, Hero, Box, AnchorNav} from '@primer/react-brand'
import {Spacer} from './components/Spacer'

const extURLs = {
  get_started: 'https://docs.github.com/actions',
  contact_sales:
    'https://github.com/enterprise/contact?ref_cta=Contact+Sales&ref_loc=hero&ref_page=%2Ffeatures%2Factions&scid=&utm_campaign=Actions_feature_page_contact_sales_cta_utmroutercampaign&utm_content=Actions&utm_medium=site&utm_source=github',
}

export function ActionsIndex() {
  return (
    <ThemeProvider colorMode="light" className="fp-hasFontSmoothing">
      {/* Header + Subnav = 136px */}
      <Spacer size="136px" />
      <Spacer size="48px" size1012="96px" />

      {/* Section Hero */}

      <section id="hero">
        <div className="fp-Section-container">
          <Hero data-hpc className="fp-Hero">
            <Hero.Label color="green">GitHub Actions</Hero.Label>
            <Hero.Heading size="2">Automate your workflow from idea to production</Hero.Heading>
            <Hero.Description size="300">
              GitHub Actions makes it easy to automate all your software workflows, now with world-class CI/CD. Build,
              test, and deploy your code right from GitHub. Make code reviews, branch management, and issue triaging
              work the way you want.
            </Hero.Description>
            <Hero.PrimaryAction href={extURLs.get_started}>Get started with actions</Hero.PrimaryAction>
            <Hero.SecondaryAction href={extURLs.contact_sales}>Contact sales</Hero.SecondaryAction>
            <Hero.Image src="/images/modules/site/actions/fp24/hero.webp" alt="TODO" />
          </Hero>

          <Box className="fp-AnchorNav">
            <AnchorNav hideUntilSticky>
              <AnchorNav.Link href="#features">Features</AnchorNav.Link>
              <AnchorNav.Link href="#pricing">Pricing</AnchorNav.Link>

              <AnchorNav.Action href={extURLs.get_started}>Get started</AnchorNav.Action>
              <AnchorNav.Action href={extURLs.contact_sales}>Contact sales</AnchorNav.Action>
            </AnchorNav>
          </Box>
        </div>
      </section>

      <Spacer size="64px" size1012="128px" />
    </ThemeProvider>
  )
}

try{ ActionsIndex.displayName ||= 'ActionsIndex' } catch {}